import styled from 'styled-components';
import { radius } from '@/styles/Themes/Metrics';
import { cssVars } from '@/styles/Themes/cssVars';
import Screen from 'src/styles/Themes/Screen';
import Text from 'src/styles/Themes/Text';
import { LeftArrow, RightArrow } from '@/common/ui';
import Palette from '@/styles/Themes/Palette';

export const Wrapper = styled.div`
    background-color: ${cssVars.bg_white_blue};
    width: 100%;
    padding: 16px 0;

    ${Screen.ipad} {
        padding: 24px 0;
    }
`;

export const Block = styled.div`
    max-width: 100%;
    position: relative;
    ${Screen.desktop} {
        padding: 0;
    }
`;

export const Header = styled.div`
    display: flex;
    position: relative;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-bottom: 8px;
`;

export const Card = styled.article`
    flex: none;
    background-color: ${cssVars.bg_white_dark3};
    border-radius: ${radius.small};
    box-shadow: ${cssVars.shadow_card_default};
    padding: 12px;
    display: flex;

    gap: 32px;
    position: relative;
    margin: 0 auto;
    font-family: 'Montserrat', sans-serif;

    ${Screen.desktop} {
        display: grid;
        grid-template-columns: 1fr 1fr;
    }
`;

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    ${Screen.desktop} {
        padding: 20px 28px;
    }
`;

export const Author = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    min-height: 38px;
    color: #4b5563;
    position: relative;
`;

export const AuthorImage = styled.div`
    width: 40px;
    height: 40px;
    border-radius: 50%;
    overflow: hidden;
    z-index: 1;
    border: solid 1px ${Palette.sand.darkSand};
    background-color: ${Palette.sand.normal};
    position: absolute;
    top: 0;
    left: 0;

    span {
        display: block !important;
    }
    image {
        display: block;
    }
`;

export const AuthorText = styled.div`
    display: flex;
    background-color: ${cssVars.bg_white_blue};
    color: ${cssVars.fg_gray2_gray3};
    border-radius: 16px;
    border: solid 1px ${cssVars.bg_gray4_dark1};
    padding: 3px 16px 3px 44px;
    position: relative;

    ${Text.Full.medium.medium}
`;

export const AuthorMeta = styled.div`
    display: flex;
    align-items: center;

    span {
        display: flex;
        align-items: center;
    }

    &::before {
        content: '|';
        margin: 0 8px;
    }
`;

export const Title = styled.h2`
    color: ${cssVars.fg_gray1_white};
    margin: 0;
    ${Text.Full.heading2}
`;

export const Description = styled.p`
    color: ${cssVars.fg_gray2_gray3};
    ${Text.Full.medium.medium}
    margin: 0;
`;

export const ReadButton = styled.a`
    display: block;
    background: transparent;
    border: 2px solid #0dd3b7;
    color: #0dd3b7;
    padding: 12px 40px;
    border-radius: 100px;
    font-family: 'Montserrat', sans-serif;
    font-weight: 500;
    cursor: pointer;
    width: fit-content;
    transition: all 0.2s ease;
    height: 50px;
    width: 100%;
    text-align: center;

    &:hover {
        background: #0dd3b7;
        color: white;
    }

    ${Screen.desktop} {
        width: fit-content;
    }
`;

export const FeaturedImage = styled.img`
    display: none;
    object-fit: cover;
    border-radius: 16px;
    width: 100%;

    ${Screen.desktop} {
        display: block;
        height: 100%;
    }
`;

export const FeaturedImageMobile = styled.img`
    object-fit: cover;
    border-radius: 16px;
    width: 100%;
    height: 100%;
    min-height: 154px;

    ${Screen.desktop} {
        display: none;
    }
`;

export const NavigationButton = styled.button<{ direction: 'left' | 'right' }>`
    position: absolute;
    top: 50%;
    ${(props) => (props.direction === 'left' ? 'left: -20px;' : 'right: -20px;')}
    transform: translateY(-50%);
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: white;
    border: none;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #4b5563;
    transition: all 0.2s ease;

    &:hover {
        background: #f3f4f6;
    }
`;

export const Dots = styled.div`
    position: absolute;
    bottom: -24px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    gap: 8px;
`;

export const Dot = styled.div<{ active?: boolean }>`
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: ${(props) => (props.active ? '#0DD3B7' : '#D1D5DB')};
`;

export const CarouselWraper = styled.div`
    position: relative;
    overflow: hidden;
    box-sizing: border-box;
    width: calc(100% + 32px);
    padding: 0 16px;
    transform: translateX(-16px);

    ${Screen.ipad} {
        width: calc(100% + 48px);
        padding: 0;
        transform: translateX(-24px);
    }

    &:after {
        content: '';
        position: absolute;
        right: 0;
        top: 0;
        bottom: 0;
        background-image: linear-gradient(to left, transparent 0%, ${cssVars.bg_white_blue} 100%);
        background-image: -webkit-linear-gradient(
            0deg,
            ${cssVars.transparent_white_blue} 0%,
            ${cssVars.bg_white_blue} 100%
        );
        width: 16px;
        z-index: 1;
        opacity: 0.9;
    }
    &:before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        background-image: linear-gradient(to right, transparent 0%, ${cssVars.bg_white_blue} 100%);
        background-image: -webkit-linear-gradient(
            180deg,
            ${cssVars.transparent_white_blue} 0%,
            ${cssVars.bg_white_blue} 100%
        );
        width: 16px;
        z-index: 1;
        opacity: 0.9;
    }
`;

export const Gallery = styled.div`
    display: flex;
    user-select: none;

    overflow-x: auto;
    scroll-behavior: smooth;
    transition: 0.5s ease 0s;
    box-sizing: border-box;

    ::-webkit-scrollbar {
        display: none;
    }

    width: calc(100% + 32px);
    padding: 16px;
    transform: translateX(-16px);

    ${Screen.ipad} {
        width: calc(100% + 48px);
        padding: 24px;
        transform: translateX(-24px);
    }
`;

export const InnerContainer = styled.div`
    gap: 24px;
    transition: 0.5s ease 0s;
    width: auto;
    display: flex;
`;

export const CenterLeftArrow = styled(LeftArrow)`
    z-index: 2;
    position: absolute;
    left: 5px;
    top: 45%;
`;

export const CenterRightArrow = styled(RightArrow)`
    z-index: 2;
    position: absolute;
    right: 5px;
    top: 45%;
`;

export const DotsSlider = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: end;
    height: 30px;
`;
